export default __webpack_public_path__ + "static/media/centro_olivos.240834f9.jpg";